import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const Confirm = ({ show, toggle, search, searchCriteria, onChange, getRecent }) => {
  return (
    <Modal isOpen={show} toggle={toggle}>
      <ModalHeader toggle={toggle}>Search Exhibits</ModalHeader>
      <ModalBody>
        <input
          type="text"
          className="form-control"
          name="searchCriteria"
          value={searchCriteria}
          onChange={onChange}
          autoFocus
        />
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-warning"
          onClick={() => {
            toggle();
            getRecent();
          }}
        >
          <i className="fa fa-list" /> Show All
        </button>

        <button type="submit" className="btn btn-success" onClick={search}>
          <i className="fa fa-search" /> Search
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default Confirm;



// WEBPACK FOOTER //
// ./src/pages/Exhibits/SearchModal.jsx